import api from '../api';

const getAllStore = async () => {


  try {
    const response = await api.get(process.env.REACT_APP_API_ENDPOINT + "/api/store/getAll");


   
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export default getAllStore;
